import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "./style.css";
import axios from "axios";
import { FeedPostMenu } from "../shared";
import EditPostPopup from "../../editPostPopup";

export default function JobServiceFeed() {
  const { user } = useSelector((state) => ({ ...state }));
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState("all");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [selectedService, setSelectedService] = useState(null);
  const [editingPost, setEditingPost] = useState(null);

  const handleEditPost = (post) => {
    setSelectedService(null);
    setEditingPost(post);
  };
  const handlePostUpdated = (updatedPost) => {
    setPosts(prev => prev.map(p => p._id === updatedPost._id ? updatedPost : p));
    setEditingPost(null);
  };
  const handlePostDeleted = (postId) => {
    setPosts(prev => prev.filter(p => p._id !== postId));
    setSelectedService(null);
  };

  const categories = [
    { id: "all", name: "Todos" },
    { id: "construction", name: "Construção" },
    { id: "cleaning", name: "Limpeza" },
    { id: "repair", name: "Reparos" },
    { id: "tech", name: "Tecnologia" },
    { id: "design", name: "Design" },
    { id: "education", name: "Educação" },
    { id: "health", name: "Saúde" },
    { id: "beauty", name: "Beleza" },
    { id: "events", name: "Eventos" },
  ];

  const fetchPosts = async (pageNum = 1) => {
    try {
      let url = `${process.env.REACT_APP_BACKEND_URL}/feed/job_service?page=${pageNum}&limit=12`;
      if (category !== "all") url += `&category=${category}`;

      const { data } = await axios.get(url, { headers: { Authorization: `Bearer ${user.token}` } });
      if (pageNum === 1) setPosts(data.posts || []);
      else setPosts((prev) => [...prev, ...(data.posts || [])]);
      setHasMore((data.pagination?.page || 1) < (data.pagination?.pages || 1));
      setLoading(false);
    } catch (error) {
      console.error("Error fetching job services:", error);
      setLoading(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { setPage(1); fetchPosts(1); }, [category]);

  if (loading && posts.length === 0) {
    return <div className="jobservice_feed_loading"><div className="jobservice_loader"></div><span>Carregando serviços...</span></div>;
  }

  return (
    <div className="jobservice_feed">
      {categories.length > 0 && (
        <div className="simple_filter_bar">
          <div className="filter_buttons">
            {categories.map((filter) => (
              <button
                key={filter.id}
                className={`filter_btn ${category === filter.id ? "active" : ""}`}
                onClick={() => setCategory(filter.id)}
              >
                {filter.name}
              </button>
            ))}
          </div>
        </div>
      )}

      {posts.length === 0 ? (
        <div className="jobservice_feed_empty">
          <svg viewBox="0 0 24 24" fill="currentColor" width="64" height="64">
            <path d="M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z"/>
          </svg>
          <h3>Nenhum serviço encontrado</h3>
          <p>Seja o primeiro a oferecer seus serviços!</p>
        </div>
      ) : (
        <div className="jobservice_list">
          {posts.map((post) => (
            <div key={post._id} className="jobservice_card" onClick={() => setSelectedService(post)}>
              <div className="jobservice_card_header">
                <Link to={`/profile/${post.user.username}`} className="jobservice_professional" onClick={(e) => e.stopPropagation()}>
                  <img src={post.user.picture} alt="" />
                  <div>
                    <h3>{post.user.first_name} {post.user.last_name}</h3>
                    <div className="jobservice_rating">
                      {[...Array(5)].map((_, i) => (
                        <svg key={i} viewBox="0 0 24 24" fill={i < Math.floor(post.jobServiceData?.rating || 5) ? "currentColor" : "none"} stroke="currentColor" width="14" height="14">
                          <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
                        </svg>
                      ))}
                      <span>({post.jobServiceData?.reviewCount || 0})</span>
                    </div>
                  </div>
                </Link>
                <span className="jobservice_category_badge">
                  {categories.find(c => c.id === post.jobServiceData?.category)?.name || "Serviço"}
                </span>
              </div>

              <div className="jobservice_card_body">
                <h4>{post.jobServiceData?.title || post.text}</h4>
                <p className="jobservice_description">{post.jobServiceData?.description}</p>

                {post.jobServiceData?.skills?.length > 0 && (
                  <div className="jobservice_skills">
                    {post.jobServiceData.skills.slice(0, 4).map((skill, i) => (
                      <span key={i}>{skill}</span>
                    ))}
                    {post.jobServiceData.skills.length > 4 && (
                      <span>+{post.jobServiceData.skills.length - 4}</span>
                    )}
                  </div>
                )}
              </div>

              <div className="jobservice_card_footer">
                <div className="jobservice_meta">
                  <span className="jobservice_experience">
                    <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
                      <path d="M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z"/>
                    </svg>
                    {post.jobServiceData?.experience || 0} anos exp.
                  </span>
                  <span className="jobservice_location">
                    <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
                      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
                    </svg>
                    {post.jobServiceData?.location || "Remoto"}
                  </span>
                </div>
                <div className="jobservice_price">
                  {post.jobServiceData?.priceType === "hourly" ? (
                    <>
                      <span className="jobservice_price_value">R$ {(post.jobServiceData?.priceMin || 0).toFixed(0)}</span>
                      <span className="jobservice_price_label">/hora</span>
                    </>
                  ) : post.jobServiceData?.priceType === "project" ? (
                    <>
                      <span className="jobservice_price_value">R$ {(post.jobServiceData?.priceMin || 0).toFixed(0)}</span>
                      <span className="jobservice_price_label"> - R$ {(post.jobServiceData?.priceMax || 0).toFixed(0)}</span>
                    </>
                  ) : (
                    <span className="jobservice_price_value">A combinar</span>
                  )}
                </div>
                <div onClick={(e) => e.stopPropagation()}>
                  <FeedPostMenu
                    post={post}
                    onEdit={handleEditPost}
                    onPostDeleted={handlePostDeleted}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {hasMore && (
        <div className="jobservice_load_more">
          <button onClick={() => { setPage(p => p + 1); fetchPosts(page + 1); }} disabled={loading}>
            {loading ? "Carregando..." : "Ver mais"}
          </button>
        </div>
      )}

      {selectedService && (
        <div className="jobservice_modal_overlay" onClick={() => setSelectedService(null)}>
          <div className="jobservice_modal" onClick={(e) => e.stopPropagation()}>
            <button className="jobservice_modal_close" onClick={() => setSelectedService(null)}>✕</button>

            <div className="jobservice_modal_header">
              <img src={selectedService.user.picture} alt="" />
              <div>
                <h2>{selectedService.user.first_name} {selectedService.user.last_name}</h2>
                <div className="jobservice_modal_rating">
                  {[...Array(5)].map((_, i) => (
                    <svg key={i} viewBox="0 0 24 24" fill={i < Math.floor(selectedService.jobServiceData?.rating || 5) ? "currentColor" : "none"} stroke="currentColor" width="18" height="18">
                      <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
                    </svg>
                  ))}
                  <span>{(selectedService.jobServiceData?.rating || 5).toFixed(1)} ({selectedService.jobServiceData?.reviewCount || 0} avaliações)</span>
                </div>
              </div>
            </div>

            <div className="jobservice_modal_body">
              <span className="jobservice_modal_category">
                {categories.find(c => c.id === selectedService.jobServiceData?.category)?.name}
              </span>
              <h3>{selectedService.jobServiceData?.title}</h3>
              <p className="jobservice_modal_desc">{selectedService.jobServiceData?.description || selectedService.text}</p>

              <div className="jobservice_modal_details">
                <div className="jobservice_detail_item">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                    <path d="M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z"/>
                  </svg>
                  <span>{selectedService.jobServiceData?.experience || 0} anos de experiência</span>
                </div>
                <div className="jobservice_detail_item">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
                  </svg>
                  <span>{selectedService.jobServiceData?.location || "Remoto"}</span>
                </div>
                <div className="jobservice_detail_item">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                    <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
                  </svg>
                  <span>{selectedService.jobServiceData?.availability || "Disponível"}</span>
                </div>
              </div>

              {selectedService.jobServiceData?.skills?.length > 0 && (
                <div className="jobservice_modal_skills">
                  <h4>Habilidades</h4>
                  <div className="jobservice_skills_list">
                    {selectedService.jobServiceData.skills.map((skill, i) => (
                      <span key={i}>{skill}</span>
                    ))}
                  </div>
                </div>
              )}

              {selectedService.jobServiceData?.certifications?.length > 0 && (
                <div className="jobservice_modal_certs">
                  <h4>Certificações</h4>
                  <ul>
                    {selectedService.jobServiceData.certifications.map((cert, i) => (
                      <li key={i}>{cert}</li>
                    ))}
                  </ul>
                </div>
              )}

              {selectedService.jobServiceData?.portfolio?.length > 0 && (
                <div className="jobservice_modal_portfolio">
                  <h4>Portfólio</h4>
                  <div className="jobservice_portfolio_grid">
                    {selectedService.jobServiceData.portfolio.slice(0, 4).map((img, i) => (
                      <img key={i} src={img} alt="" />
                    ))}
                  </div>
                </div>
              )}
            </div>

            <div className="jobservice_modal_footer">
              <div className="jobservice_modal_price">
                {selectedService.jobServiceData?.priceType === "hourly" ? (
                  <>
                    <span>R$ {(selectedService.jobServiceData?.priceMin || 0).toFixed(0)}</span>
                    <span>/hora</span>
                  </>
                ) : (
                  <>
                    <span>R$ {(selectedService.jobServiceData?.priceMin || 0).toFixed(0)}</span>
                    <span> - R$ {(selectedService.jobServiceData?.priceMax || 0).toFixed(0)}</span>
                  </>
                )}
              </div>
              <button className="jobservice_contact_btn">Contratar serviço</button>
            </div>
          </div>
        </div>
      )}

      {editingPost && (
        <EditPostPopup
          post={editingPost}
          user={user}
          setVisible={(visible) => !visible && setEditingPost(null)}
          onPostUpdated={handlePostUpdated}
        />
      )}
    </div>
  );
}
